import { newTemplate } from '../../util/scriptLogTemplate'
import { removeObjectKey } from '../../util/state'
import { delay } from '../../util/pseudoApi'

let allTemplates = {}
let activeTemplateId = null

const firstTemplate = newTemplate('First Template')
allTemplates[firstTemplate.id] = firstTemplate
activeTemplateId = firstTemplate.id

const secondTemplate = newTemplate('Second Template')
allTemplates[secondTemplate.id] = secondTemplate

export const getTemplates = async () => {
  await delay()
  return allTemplates
}

export const getActiveTemplateId = async () => {
  await delay()
  return activeTemplateId
}

export const createTemplate = async name => {
  const template = newTemplate(name)
  allTemplates[template.id] = template
  activeTemplateId = template.id

  await delay()
  return allTemplates[template.id]
}

export const changeActiveTemplateId = async id => {
  activeTemplateId = id

  await delay()
  return activeTemplateId
}

export const updateTemplate = async (id, entry) => {
  allTemplates[id] = {
    id,
    ...entry,
    name: allTemplates[id].name
  }

  await delay()
  return allTemplates[id]
}

export const deleteTemplate = async id => {
  allTemplates = removeObjectKey(allTemplates, id)

  activeTemplateId = Object.keys(allTemplates)[0]

  await delay()
  return true
}


// WEBPACK FOOTER //
// ./services/pseudoApi/template.js